import styles from './radiorer.less'; export {styles};

interface RadiorerStyles {
    radiorer?: string;
    checked?: string;
    label?: string;
}

interface RadiorerProps {
    name?: string;
    size?: 20 | 22;
    label?: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    styles?: RadiorerStyles;
}

export default class Radiorer extends React.PureComponent<RadiorerProps, null> {

    protected readonly _inputRef = React.createRef<HTMLInputElement>();
    protected readonly _id;

    constructor(props) {
        super(props);

        this._id = AitiCore.getUtils().getUniqueId('radiorer');
    }

    isChecked(): boolean {
        return this._inputRef.current.checked;
    }

    render() {
        const {size = 20} = this.props;

        return (
            <>
                <label className={classNames(styles.radiorer, this.props.styles?.radiorer, styles['size-' + size])}>
                    <input type="radio" id={this._id} name={this.props.name} checked={this.props.checked} onChange={() => this.props.onChange?.(this.isChecked())} ref={this._inputRef}/>
                    <span/>
                </label>{this.props.label && (<label htmlFor={this._id} className={classNames(styles.label, this.props.styles?.label)}>{this.props.label}</label>)}
            </>
        );
    }
}
